// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-main {
  min-height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-box {
  display: inline-block;
  margin: auto;
  background-color: white;
  padding: 4rem 2rem;
  border-radius: 0.25rem;
}

.welcome-box h4 {
    margin-top: 1rem;
}

.steps-list {
  margin: 2rem 3rem 3rem;
}

  .steps-list li {
    counter-increment: step-counter;
    list-style: none;
    text-align: left;
    margin-bottom: 0.6rem;
  }

    .steps-list li::before {
      content: counter(step-counter);
      margin-right: 1rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      background-color: #dde4e6;
      border-radius: 50%;
    }

.relogin-content p {
    margin-top: 3rem;
    margin-bottom: 5rem;
}

.welcome-auth {
  align-self: center;
  justify-self: center;
}

body {
  max-width: 150rem;
}

@media (max-width: 599px) {
  .welcome-box {
    width: 90%;
    height: 60%;
    margin: auto;
    padding: 2rem;
  }

  .steps-list {
    margin: 3rem 1rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Welcome/Welcome.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;EAEE;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;IAEE;MACE,8BAA8B;MAC9B,kBAAkB;MAClB,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;IACpB;;AAEJ;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".welcome-main {\r\n  min-height: 100vh;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.welcome-box {\r\n  display: inline-block;\r\n  margin: auto;\r\n  background-color: white;\r\n  padding: 4rem 2rem;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.welcome-box h4 {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.steps-list {\r\n  margin: 2rem 3rem 3rem;\r\n}\r\n\r\n  .steps-list li {\r\n    counter-increment: step-counter;\r\n    list-style: none;\r\n    text-align: left;\r\n    margin-bottom: 0.6rem;\r\n  }\r\n\r\n    .steps-list li::before {\r\n      content: counter(step-counter);\r\n      margin-right: 1rem;\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: 2rem;\r\n      height: 2rem;\r\n      background-color: #dde4e6;\r\n      border-radius: 50%;\r\n    }\r\n\r\n.relogin-content p {\r\n    margin-top: 3rem;\r\n    margin-bottom: 5rem;\r\n}\r\n\r\n.welcome-auth {\r\n  align-self: center;\r\n  justify-self: center;\r\n}\r\n\r\nbody {\r\n  max-width: 150rem;\r\n}\r\n\r\n@media (max-width: 599px) {\r\n  .welcome-box {\r\n    width: 90%;\r\n    height: 60%;\r\n    margin: auto;\r\n    padding: 2rem;\r\n  }\r\n\r\n  .steps-list {\r\n    margin: 3rem 1rem;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
